import React from 'react';
import {observer} from 'mobx-react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import styles from "../styles/live-penalties-module.module.scss";
import classNames from "classnames";
import {LivePenaltiesModuleController} from "../live-penalties-module.controller";
import {EntityCarousel} from "../../../core/components/entity-carousel/entity-carousel";
import {
  AthleteChartEventsViewModel
} from "../../../domain/full-game/models/chart-events/athlete-chart-events/athlete-chart-events.view-model";
import {LIVE_PENALTIES} from "../live-penalties-module.consts";
import {ShotMapGoalView} from "../../../core/components/shot-map/goal-view/shot-map.goal-view";
import {SeperatedCardsList} from "../../../core/components/seperated-cards-list/seperated-cards-list";

export class LivePenaltiesModuleContentProps extends BaseProps {
  controller: LivePenaltiesModuleController;
}

export const LivePenaltiesModuleContent = observer(({controller}: LivePenaltiesModuleContentProps) => {
  const {state, device} = controller;
  const {
    athletesChartEvents,
    selectedAthleteChartEvent,
    selectedAthlete,
    selectedPlayerIndex,
    activeItemWidth,
    terms
  } = state;
  const {isSmallView, isRtl} = device;

  const onPlayerChange = (player: AthleteChartEventsViewModel) => controller.action(LIVE_PENALTIES.ACTION_TYPES.onPlayerChange, {
    athleteId: player.id,
  });

  const carouselProps = {
    entities: athletesChartEvents.map((athletesChartEvent: AthleteChartEventsViewModel) => athletesChartEvent.athlete),
    itemIndex: selectedPlayerIndex,
    onItemChange: onPlayerChange,
    activeItemWidth,
    isSingleItem: athletesChartEvents?.length === 1,
    isSmallView,
    isRtl
  }

  const seperatedCardsListProps = {
    values: selectedAthleteChartEvent?.mainStats,
    className: styles.athlete_shots_details_container,
    terms
  }

  const shotChartProps = {
    controller,
    events: selectedAthleteChartEvent?.events,
    forceBigScale: true,
    forceAllShotsActive: true,
    shouldRenderEventDetails: false
  }

  return (
    <div className={classNames(styles.content_container)}>
      <div className={classNames(styles.carousel_container)}>
        <EntityCarousel {...carouselProps}/>
        <div className={classNames(styles.header_title_name)}>{selectedAthlete?.name}</div>
      </div>
      <SeperatedCardsList {...seperatedCardsListProps}/>
      <ShotMapGoalView {...shotChartProps}/>
    </div>

  )
})
